export default {"src":"/_next/static/media/Fallback.82051d83.svg","height":125,"width":125,"blurWidth":0,"blurHeight":0};